import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchClients as fetchClientsDataApi } from "../../api"; // Import from api.js

// Async thunk for fetching dashboard data
export const fetchClientsData = createAsyncThunk(
  "clients/fetchClientsData",
  async (_, { rejectWithValue }) => {
    try {
      // Use the function from api.js
      const data = await fetchClientsDataApi();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch dashboard data");
    }
  }
);

const clientSlice = createSlice({
  name: "clients",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClientsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClientsData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchClientsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetError } = clientSlice.actions;
export default clientSlice.reducer;
